import React, { Component, Suspense } from "react";
import * as ReactDOM from "react-dom";
import Slider from "react-slick";
import edit from "../image/icons/edit.png";
import plus from "../image/icons/plus.png";
import $ from "jquery";
import InnerHTML from "dangerously-set-html-content";
const folderName = window.sessionStorage.getItem("homeName");
export default class about extends Component {  
  constructor(props) {
  super(props);
  this.state = {
    aboutData: [],
    sectionName:'About',
    parentName:''
    
  };
}
componentDidMount() {
  const About = JSON.parse(window.sessionStorage.getItem("About"));
  if (About) {
    this.setState({ aboutData: About });
    this.setState({ parentName: About[0].parentName });
    
  } else {
    this.setState({ aboutData: []});

    // window.location.reload(false);
  }
}

addClick(sid,pId,cId,ptitle,pstitle,cTitile,cdescri,childImg,sOrder) {
  if($("#aboutParentId").val()!== "") {
    pId=$("#aboutParentId").val();
  }
  if(childImg){
    var splitImg=childImg.split("theme/")
    childImg=splitImg[1];
    }

  const LazyPage = React.lazy(() => import("../" + folderName + "/ThemeComponent"));
  ReactDOM.render(
    <div>
      <Suspense fallback={<div>Loading...</div>}>
        <section>
          <LazyPage
             sessionId={sid} 
             parentId={pId}
             childId={cId}
             patentTitle={ptitle}
             parentSubTitle={pstitle}
             childTitle={cTitile}
             childDesri={cdescri}
             sectionName={this.state.sectionName}
             childImg={childImg}
             sortSubOrder={sOrder}
          />
        </section>
      </Suspense>
    </div>,
    document.getElementById("aboutpopUpBlock")
  );
  $("#aboutpopUpBlock").addClass("editActive");
}



  render() {
    var settings = {
      dots: false,
      fade: true,
      infinite: true,
      autoplay: true,
      arrows: true,
      autoplaySpeed: 6000, 
      pauseOnHover: false,
    };
    const urlPath = window.location.origin.toString();
    return (
        <div class="about-mainwapper">
            {this.props.themeFlag === "theme" && (
         <div className="editIconSec" id="About">
            <span
              className="editIcon editAddIcon"
              title="Add"
              onClick={() => this.addClick("5","","","","","","","","","")}
            >
              <img src={plus} alt="Add" />
            </span>
        
          </div>
        )}
        <div className="cmsContentDiv" id="aboutpopUpBlock"></div>
        {this.props.themeFlag === "theme" && (
        <h4 class="mainHead">{this.state.parentName!= '' ? 'About Session' : 'About Session'}</h4>
        )}
        <input type="hidden" id="aboutSectionId" value="5" />
        <div class="container">
        {this.state.aboutData.map((ban) => {
          return (
          <div>
                <h4 className="mainHead">
              <span>{ban.parentName}</span>
            </h4>
        <input type="hidden" id="aboutParentId" value={ban.parentId} />
        {ban.sectionList.length !== "0" && (
            <span>
            {ban.sectionList.map((data) => (
            <div class="about-main row">
            {this.props.themeFlag === "theme" && (
            <div className="editIconSec">
                          <span
                            className="editIcon editAddIcon"
                            title="Edit"
                            onClick={() =>
                              this.addClick
                              (ban.sectionId,
                                ban.parentId,
                                data.childId,
                                ban.parentName,
                                ban.parentSubTitle,
                                data.childName,
                                data.childDescription,
                                data.childImage,
                                data.homeAdsSubSortOrder)
                            }
                          >
                            <img src={edit} alt="edit" />
                          </span>
                        </div>
                         )}
                   <div className="aboutImageDiv col-lg-5">
                    <img src={data.childImage} alt="about" className="img-fluid"/>
                </div>
                <div class="col-lg-7">
                  <div class="aboutContent col-lg-12 p-0">
                      {/* <p>{data.childName}</p> */}
                      <p> <InnerHTML html={data.childDescription.length >1040 ?
                        data.childDescription.substring(0, data.childDescription.substring(0, 1040).lastIndexOf(" ")) + '...'
                         : 
                         data.childDescription}  /></p>
                  </div>
                  {data.childDescription.length > 1040 ?
                  <div className="col-md-12 p-0 mt-2">
                     <a href={(urlPath, "/1-aboutMe" )} class="aboutButton">Read More</a>
                  </div>
                    : ''}
                    
                </div>
                </div>
                ))}
           </span>
            )}
            </div>
         );
        })}
        </div>
      </div>
    );
  }
}
